// src/pages/DiaryHubPage.tsx
import React from 'react';
import { Card, Col, Row, Typography, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';

const { Title, Text } = Typography;

const DIARIES = [
  { key: 'glucose', title: 'Глюкоза', path: '/diary/glucose', color: '#EF5350', desc: 'Измерения сахара в крови' },
  { key: 'nutrition', title: 'Питание', path: '/diary/nutrition', color: '#FB8C00', desc: 'Приёмы пищи и калории' },
  { key: 'weight', title: 'Вес', path: '/diary/weight', color: '#42A5F5', desc: 'Контроль веса' },
  { key: 'movements', title: 'Шевеления', path: '/diary/movements', color: '#7CB342', desc: 'Движения малыша' },
  { key: 'symptoms', title: 'Симптомы', path: '/diary/symptoms', color: '#8D6E63', desc: 'Самочувствие' },
  { key: 'abdomen', title: 'Окружность живота', path: '/diary/abdomen', color: '#26A69A', desc: 'Замеры и фото' },
  { key: 'visits', title: 'Визиты к врачу', path: '/diary/visits', color: '#5C6BC0', desc: 'Приёмы и документы' },
  { key: 'lab-tests', title: 'Анализы', path: '/diary/lab-tests', color: '#78909C', desc: 'Результаты исследований' },
];

export const DiaryHubPage: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', width: '100%' }}>
      <div style={{ marginBottom: isMobile ? 16 : 24 }}>
        <Title level={isMobile ? 3 : 2} style={{ color: '#263238', marginBottom: 8 }}>
          Дневники
        </Title>
        <Text type="secondary">Выберите дневник, чтобы добавить или изменить записи</Text>
      </div>

      <Row gutter={[16, 16]}>
        {DIARIES.map((diary) => (
          <Col xs={24} sm={12} lg={8} key={diary.key}>
            <Card
              hoverable
              onClick={() => navigate(diary.path)}
              style={{
                borderRadius: 16,
                borderTop: `3px solid ${diary.color}`,
                height: '100%',
              }}
              bodyStyle={{ padding: 20 }}
            >
              <Space direction="vertical" size={4}>
                <Text strong style={{ fontSize: 16, color: '#263238' }}>
                  {diary.title}
                </Text>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  {diary.desc}
                </Text>
              </Space>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};
